import {
  type AiAgentSection,
  type OpenWidgetMarketplaceEvent,
  WIDGET_MARKETPLACE_CATEGORY_ALL,
  type WidgetRelatedApp
} from '@inno-tools/container-bridge'

export interface ResolvedMarketplaceCategory {
  relatedApp: WidgetRelatedApp | null
  section: AiAgentSection | null
}

export const resolveMarketplaceCategory = (
  data: OpenWidgetMarketplaceEvent['data'] | undefined
): ResolvedMarketplaceCategory => {
  if (
    !data ||
    data.category == null ||
    data.category === WIDGET_MARKETPLACE_CATEGORY_ALL
  ) {
    return { relatedApp: null, section: null }
  }

  return {
    relatedApp: data.category,
    section: data.section ?? null
  }
}
